import React, { useState } from "react";
import { Row, Col, Button, Container, Label, Input, FormGroup } from "reactstrap";
import { Link } from "react-router-dom";
import logodark from "../../assets/images/logo-dark.png";

const Register = () => {
    const API_URL = process.env.REACT_APP_APIURL;

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const handelName = (value) => setName(value);
    const handelEmail = (value) => setEmail(value);   // ✅ fixed here
    const handelPassword = (value) => setPassword(value);

    const handelRegister = async (e) => {
        e.preventDefault();

        const data = {
            userName: name,
            userEmail: email,
            userPassword: password
        };

        try {
            const res = await fetch(`${`https://api.myhappywheels.com/api`}/user/register`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data)
            });

            if (res.ok) {
                alert("Registration successful 🎉");
            } else {
                const err = await res.json();
                alert(`Error: ${err.message || "Something went wrong"}`);
            }
        } catch (error) {
            console.error("Error registering:", error);
            alert("Server error, please try again later.");
        }
    };

    return (
        <div>
            <Container fluid className="p-0">
                <Row className="g-0">
                    <Col lg={4}>
                        <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                            <div className="w-100">
                                <Row className="justify-content-center">
                                    <Col lg={9}>
                                        <div className="text-center">
                                            <Link to="#" className="logo">
                                                <img src={logodark} height="20" alt="logo" />
                                            </Link>
                                            <h4 className="font-size-18 mt-4">Register account</h4>
                                            <p className="text-muted">Get your free account now.</p>
                                        </div>

                                        <div className="p-2 mt-5">
                                            <form className="form-horizontal" onSubmit={handelRegister}>
                                                <FormGroup className="mb-4">
                                                    <Label htmlFor="useremail">Email</Label>
                                                    <Input
                                                        type="email"
                                                        id="useremail"
                                                        placeholder="Enter email"
                                                        value={email}
                                                        onChange={(e) => handelEmail(e.target.value)}
                                                    />
                                                </FormGroup>

                                                <FormGroup className="mb-4">
                                                    <Label htmlFor="username">Username</Label>
                                                    <Input
                                                        type="text"
                                                        id="username"
                                                        placeholder="Enter username"
                                                        value={name}
                                                        onChange={(e) => handelName(e.target.value)}
                                                    />
                                                </FormGroup>

                                                <FormGroup className="mb-4">
                                                    <Label htmlFor="userpassword">Password</Label>
                                                    <Input
                                                        type="password"
                                                        id="userpassword"
                                                        placeholder="Enter password"
                                                        value={password}
                                                        onChange={(e) => handelPassword(e.target.value)}
                                                    />
                                                </FormGroup>

                                                <div className="text-center">
                                                    <Button color="primary" type="submit">
                                                        Register
                                                    </Button>
                                                </div>
                                            </form>
                                        </div>

                                        <div className="mt-5 text-center">
                                            <p>
                                                Already have an account?{" "}
                                                <Link to="/login" className="fw-medium text-primary">
                                                    Login
                                                </Link>
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                    <Col lg={8}>
                        <div className="authentication-bg">
                            <div className="bg-overlay"></div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Register;
